export default "__VITE_ASSET__B_ZFr2TS__"